const _primaryNav = document.getElementById('primary-nav');

if (_primaryNav) {
	new AccessibleMenu.Menubar({
		menuElement: _primaryNav,
		submenuItemSelector: 'li.dropdown',
		hoverType: 'on',
		openClass: 'is-open',
		closeClass: 'is-closed',
	});
}

new AccessibleMenu.Menubar({
	menuElement: document.getElementById('secondary-nav'),
	submenuItemSelector: 'li.dropdown',
	hoverType: 'on',
	openClass: 'is-open',
	closeClass: 'is-closed',
});

/*new AccessibleMenu.Menubar({
	menuElement: document.getElementById('mobile-menu-items'),
	submenuItemSelector: 'li.dropdown',
	openClass: 'is-open',
	closeClass: 'is-closed',
});*/

/*new AccessibleMenu.Treeview({
	menuElement: document.getElementById('sidebar-nav'),
	submenuItemSelector: 'li.dropdown',
	openClass: 'is-open',
	closeClass: 'is-closed',
});*/